import { Bin } from '../types/bin';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/bin/list';

export namespace BinRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<Bin>> => {
    return (await http.post(LIST, payload)).data;
  };
}
